
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"2","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.984 2.813a.91.91 0 01-.68-.282 1.016 1.016 0 01-.273-.726c0-.292.091-.532.274-.72a.898.898 0 01.68-.288c.27 0 .497.096.68.289a.988.988 0 01.272.719c0 .291-.09.534-.273.726a.91.91 0 01-.68.281zm0 4.156a.91.91 0 01-.68-.282 1.016 1.016 0 01-.273-.726c0-.292.091-.531.274-.719a.898.898 0 01.68-.289c.27 0 .497.096.68.29a.988.988 0 01.272.718c0 .292-.09.534-.273.726a.91.91 0 01-.68.282zm0 4.156a.91.91 0 01-.68-.281 1.016 1.016 0 01-.273-.727c0-.291.091-.531.274-.719a.898.898 0 01.68-.289c.27 0 .497.097.68.29a.988.988 0 01.272.718c0 .292-.09.534-.273.727a.91.91 0 01-.68.281z","fill":"currentColor"}})])
          )
        }
      }
    